import _ from 'underscore';

import template from './template.html';

function FeesDirective() {
  return {
    restrict: 'E',
    scope: {
      config: '='
    },
    require: 'ngModel',
    controller: 'feesCtrl',
    controllerAs: 'vm',
    template,
    bindToController: true,
    link: function (scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$formatters.push(function (modelValue) {
        return modelValue;
      });

      ngModelCtrl.$render = function () {
        scope.vm.fees = ngModelCtrl.$viewValue || [];
      };

      ngModelCtrl.$parsers.push(function (viewValue) {
        return viewValue;
      });

      // Deep watch fees and mark as touched if changes are made
      scope.$watch('vm.fees', function (newValue, oldValue) {
        if (_.difference(newValue, oldValue).length) {
          ngModelCtrl.$setViewValue(newValue);
          ngModelCtrl.$dirty = true;
        }
      }, true);

      scope.vm.config.initialized = true;
    }
  };
}

FeesDirective.$inject = [];

export default FeesDirective;



// WEBPACK FOOTER //
// ./src/directives/fees/index.js